import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from '../services/apiservices.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent {
  loginForm: FormGroup;
  loader = false;
  submitted = false;

  hideOld = true;
  hideNew = true;
  hideConfirm = true;
  public login_user_details: any = {};

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    public cookieService: CookieService,
    private apiService: ApiservicesService,
    private location: Location
  ) {
    this.loginForm = this.fb.group(
      {
        oldPassword: ['', Validators.required],
        newPassword: [
          '',
          [
            Validators.required,
            // Validators.pattern(
            //   /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/
            // ),
          ],
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
            Validators.pattern(
              /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/
            ),
          ],
        ],
      },
      { validators: this.passwordsMatchValidator }
    );

    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};
  }

  // Custom validator to ensure newPassword and confirmPassword match
  private passwordsMatchValidator(form: FormGroup) {
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  }

  setPassword() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const formData = {
      username: this.login_user_details.userinfo.email, // from cookie
      oldPassword: this.loginForm.value.oldPassword,
      newPassword: this.loginForm.value.newPassword,
    };

    this.loader = true;

    this.apiService
      .getHttpDataPost('user/change-password', formData)
      .subscribe({
        next: (res: any) => {
          this.loader = false;
          this.snackBar.open(
            res?.message || 'Password changed successfully!',
            'OK',
            {
              duration: 5000,
            }
          );
          this.loginForm.reset();
          this.submitted = false;
          this.location.back();
        },
        error: (error: any) => {
          this.loader = false;
          this.snackBar.open(error?.message || 'Error fetching data', 'OK', {
            duration: 5000,
          });
        },
      });
  }
}
